import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    semanas: [],
    zonas: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const OBTENER_SEMANAS_BY_ID_ZONA = 'OBTENER_SEMANAS_BY_ID_ZONA'
const OBTENER_TODAS_LAS_ZONAS = 'OBTENER_TODAS_LAS_ZONAS'
const AGREGAR_MESZONA = 'AGREGAR_MESZONA'
//*******************************************************************************************************************


//MÉTODOS 

export const agregarMesZona = createAsyncThunk(
    AGREGAR_MESZONA,
    async (data) => {
        try {
            const fullUrl = host + `MesZona/agregarMesZona`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarInspector = createAsyncThunk(
    AGREGAR_MESZONA,
    async (data) => {
        try {
            const fullUrl = host + `MesZona/actualizarInspector`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerDiasByIdZona = createAsyncThunk(
    OBTENER_SEMANAS_BY_ID_ZONA,
    async (idzona) => {
        try {
            const fullUrl = host + `Calendario/obtenerDiasByIdZona/${parseInt(idzona)}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerMesZona = createAsyncThunk(
    OBTENER_TODAS_LAS_ZONAS,
    async (idzona) => {
        try {
            const fullUrl = host + `MesZona/obtenerMesZona`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosMesZonaSlice = createSlice({

    name: 'metodosMesZonaSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerDiasByIdZona.fulfilled]: (state, { payload }) => {
            state.semanas = payload.data.data
        },
        [obtenerMesZona.fulfilled]: (state, { payload }) => {
            state.zonas = payload.data.data
        },
        [actualizarInspector.fulfilled]: (state, { payload }) => {

        }
    },

})


export const { } = metodosMesZonaSlice.actions
export const MesZonaReducer = metodosMesZonaSlice.reducer